export function didUserInfoChanged(prevErr, prevUserInfo, err, userInfo) {
    if (prevErr != err) {
        return true;
    }

    return userInfo.profileSite.id !== prevUserInfo.profileSite.id;
}

function findGroupSite(site) {
    return site.type_name.toLowerCase() === "group";
}

export function getUserCommunity(userInfo) {
    const communitySite = userInfo.sites.find(findGroupSite);
    if (communitySite && communitySite.permissions.edit_folder_items) {
        return communitySite.id;
    } else {
        return null;
    }
}

export function canManageLabels(userInfo) {
    return !!userInfo.profileSite.permissions.edit_folder_items;
}
